import { CircularProgress } from '@mui/material';
import AppAdminTable from 'components/AppAdminTable/AppAdminTable';
import ListPage from 'components/ListPage/ListPage';
import { useRemoteResource } from 'hooks/useRemoteResource';
import rolesAdminService from 'services/admin/rolesService';

const listConfig = [
    {
        key: "order",
        label: "#",
        render: (v, i) => i + 1
    },
    {
        key: 'name',
        label: 'Название'
    },
    {
        key: 'systemName',
        label: 'Системное название'
    },
]

export const RoleList = () => {
    const [data, loadData, loading] = useRemoteResource(rolesAdminService.getAll, "");

    const onDelete = async (u) => {
        await rolesAdminService.delete(u.id);
        loadData();
    };

    if (loading) {
        return <div className="text-center"><CircularProgress></CircularProgress></div>
    }

    return (
        <ListPage pageTitle="Роли">
            <AppAdminTable
                columnConfig={listConfig}
                data={data || []}
                onDelete={onDelete}
                loading={loading}
            />
        </ListPage>
    );
}
